import { DatasourceColumnUIModel } from '@y42/datasource';
import { OperationsFilterModel } from '@y42/json-schema';

export class TransformFilterModel {
  constructor(
    public global_op: string[] = ['AND'],
    public filterOps: OperationsFilterModel[] = [],
    public filters?: string,
    public filter_fields?: DatasourceColumnUIModel[],
    public filterGroups?: string[],
  ) {}
}
